var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"pointer",staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/financial/banner.png")},on:{"click":_vm.$login}}),_c('text-left',{attrs:{"text-left":{
      height: 400,
      title: '在结账期自动巡检账套并发现常见信息缺失，确保数据完整',
      desc: '通过自动巡检，筝鸣将从资产类、期末处理类、往来类、纳税调整类、以及其他类期末处理事项进行全面检测，充分提示账务处理风险，进一步确保期末结账数据的准确性。',
      textWidth: 880,
      imgWidth: 250,
      left: false,
      img: require('@/assets/financial/img3.png')
    }}}),_c('text-left',{attrs:{"text-left":{
      height: 420,
      title: '业务系统类巡检',
      desc: '通过自动巡检，筝鸣还会全面检测销售、采购、费用报销、收付款、银行对账单等业务系统环节，确保银行流水与业务交易完全勾对匹配，账实相符，数据完整。',
      textWidth: 750,
      imgWidth: 270,
      left: true,
      img: require('@/assets/financial/img1.png')
    }}}),_c('text-left',{attrs:{"text-left":{
      height: 450,
      title: '期初余额确认',
      desc: '财务核算是完整、连续而系统的，之前期间内任何数据上的错误都会对后期财务核算的准确性产生重大影响。自动巡检帮您在数据上把好关，一次巡检，多重保障。',
      textWidth: 720,
      imgWidth: 320,
      left: false,
      img: require('@/assets/financial/img2.png')
    }}}),_c('part-list',{attrs:{"part-list":_vm.list}}),_c('Ready')],1)}
var staticRenderFns = []

export { render, staticRenderFns }